import React, {useEffect, useState} from "react";
import Space from "../../commons/Space";
import ScrollToTopOnMount from "../../components/ScrollToTopOnMount";
import FrecciaIndietro from "../../commons/FrecciaIndietro";
import 'bs5-lightbox';
import SpaceL from "../../commons/SpaceL";
import "../../styles/Master.css";
import TitoloColore from "../../commons/TitoloColore";
import foto1 from "../../images/Nuoto/Ago/Sebastian Argento 200 MX Junior.jpeg"
import foto2 from "../../images/Nuoto/Ago/Vania Bronzo 100DR Esordienti A .jpeg"
import foto3 from "../../images/Nuoto/Ago/Oro Staffetta 50 SL Juniores.jpeg"
import foto4 from "../../images/Nuoto/Ago/Corrado Argento 200 MX Ragazzi.jpeg"
import foto5 from "../../images/Nuoto/Ago/Lavinia Argento 200 MX Ragazzi.jpeg"
import ReactPlayer from "react-player";


function GarePreAgo() {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return (

        <div>
            <ScrollToTopOnMount />
            <TitoloColore title={"Agonismo"} backgroundColor={"#003F83"} />
            <FrecciaIndietro indirizzo={"/corsinuoto"} />
            <div style={{padding: "1em"}}>
                <div
                    className="d-flex flex-row justify-content-start justify-content-md-center container-news"
                    style={{ overflowX: "auto", whiteSpace: "nowrap", padding: "1em 0" }}
                >
                    <img src={foto1} className="img-fluid img-thumbnail news-img" style={{ flex: "0 0 auto", maxWidth: "80%", marginRight: "10px" }} alt="..." />
                    <img src={foto2} className="img-fluid img-thumbnail news-img" style={{ flex: "0 0 auto", maxWidth: "80%", marginRight: "10px" }} alt="..." />
                    <img src={foto3} className="img-fluid img-thumbnail news-img" style={{ flex: "0 0 auto", maxWidth: "80%", marginRight: "10px" }} alt="..." />
                    <img src={foto4} className="img-fluid img-thumbnail news-img" style={{ flex: "0 0 auto", maxWidth: "80%", marginRight: "10px" }} alt="..." />
                    <img src={foto5} className="img-fluid img-thumbnail news-img" style={{ flex: "0 0 auto", maxWidth: "80%" }} alt="..." />
                </div>
                <SpaceL />
                <h3 className="text-center">
                    <a href="https://www.uisp.it/monzabrianza2/nuoto/area-risultati-nuoto" target="_blank" rel="noopener noreferrer" className="text-center" style={{  padding: "1em", fontFamily: "Hammersmith One", color: "#032041" }}> Risultati gare </a>
                </h3>
                <SpaceL />

                {windowWidth > 900 ? (
                        <ReactPlayer config={{ file: {
                                attributes: {
                                    controlsList: 'nodownload'
                                }}
                        }}
                                     style={{margin: "auto"}}
                                     url='https://www.ilcignosport.it/Dimostrazione_agonisti.mp4'
                                     controls={true}

                        />
                    ):
                    windowWidth > 650 && windowWidth < 900 ? (
                            <ReactPlayer config={{ file: {
                                    attributes: {
                                        controlsList: 'nodownload'
                                    }}}} style={{margin: "auto"}} url='https://www.ilcignosport.it/Dimostrazione_agonisti.mp4' controls={true} width={"100%"} height={"auto"}/>
                        )
                        : (
                            <ReactPlayer config={{ file: {
                                    attributes: {
                                        controlsList: 'nodownload'
                                    }}
                            }}
                                         style={{margin: "auto"}}
                                         url='https://www.ilcignosport.it/Dimostrazione_agonisti.mp4'
                                         controls={true}
                                         width={"100%"}
                                         height={"auto"}
                            />
                        )}
                <Space />

                <Space />
            </div>
        </div>
    )
}

export default GarePreAgo;
